"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["width", "height", "viewBox", "fill", "title"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TwitchLogo = function TwitchLogo(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 40 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 40 : _ref$height,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? "0 0 400 400" : _ref$viewBox,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? "#fffffe" : _ref$fill,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Twitch Logo" : _ref$title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: height,
    width: width,
    x: "0",
    y: "0",
    viewBox: "0 0 2400 2800"
  }, rest), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M500 0 0 500v1800h600v500l500-500h400l900-900V0H500zm1700 1300-400 400h-400l-350 350v-350H600V200h1600v1100z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1700 550h200v600h-200zM1150 550h200v600h-200z"
  })));
};
var _default = exports["default"] = TwitchLogo;